import React from 'react';
import {useLocation, useNavigate} from 'react-router-dom';
import {useSidebar} from '../context/SidebarContext';

const Sidebar = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { isOpen, setIsOpen } = useSidebar();

  const menuItems = [
    { name: 'Kampanie', path: '/campaigns' },
    { name: 'Scenariusze', path: '/scenarios' },
    { name: 'Szablony Email', path: '/email-templates' }
  ];

  return (
    <div className="min-h-screen">
      {/* Hamburger button */}
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="fixed top-4 left-4 z-50 p-2 rounded-lg bg-white shadow-lg hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500"
      >
        <svg
          className="h-6 w-6 text-gray-600"
          fill="none"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          {isOpen ? (
            <path d="M6 18L18 6M6 6l12 12" />
          ) : (
            <path d="M4 6h16M4 12h16M4 18h16" />
          )}
        </svg>
      </button>

      {/* Sidebar */}
      <aside
        className={`fixed top-0 left-0 h-full bg-white shadow-lg transform transition-transform duration-300 ease-in-out z-40 w-64
          ${isOpen ? 'translate-x-0' : '-translate-x-full'}`}
      >
        <div className="p-6 mt-16 flex flex-col h-[calc(100%-4rem)]">
          <h2 className="text-xl font-bold text-gray-900 mb-6">Menu</h2>
          <nav className="space-y-2">
            {menuItems.map((item) => (
              <button
                key={item.path}
                onClick={() => {
                  navigate(item.path);
                  if (window.innerWidth < 1024) {
                    setIsOpen(false);
                  }
                }}
                className={`w-full px-4 py-2 text-left rounded-lg transition-colors ${
                  location.pathname === item.path
                    ? 'bg-blue-50 text-blue-700 font-medium'
                    : 'text-gray-600 hover:bg-gray-50'
                }`}
              >
                {item.name}
              </button>
            ))}
          </nav>
          
          {/* Footer links */}
          <div className="mt-auto border-t pt-4">
            <button
              onClick={() => navigate('/about')}
              className={`w-full px-4 py-2 text-left rounded-lg transition-colors ${
                location.pathname === '/about'
                  ? 'bg-blue-50 text-blue-700 font-medium'
                  : 'text-gray-600 hover:bg-gray-50'
              }`}
            >
              O aplikacji
            </button>
          </div>
        </div>
      </aside>

      {/* Main content area */}
      <main className={`min-h-screen transition-all duration-300 ${isOpen ? 'pl-64' : 'pl-0'}`}>
        <div className="p-4 pt-20">
          {children}
        </div>
      </main>
    </div>
  );
};

export default Sidebar; 